import React from "react";
import logo from "../../../images/logo.svg";

const UploadImgMain = ({ closeModal, previewModal }) => {
  return (
    <div className="modal">
      <div className="modal-content">
        <div className="modal-header">
          <img src={logo} alt="logo" className="h-10 w-10 rounded-full" />
          <button className="close" onClick={closeModal}>
            ×
          </button>
        </div>
        <div className="modal-body">
          <h3>Upload Photo</h3>
          <p>Choose a photo to create your meme</p>
          <div className="upload-area">
            <input type="file" id="img" accept="image/*" />
            <label htmlFor="img">Choose Photo</label>
          </div>
          <button className="preview" onClick={previewModal}>
            Preview
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadImgMain; 